import React, { useEffect, useState } from 'react'
import { Button, Card, Drawer, Form, notification } from 'antd'
import { InputBox } from '../../../components/_utils/appUtils'

let initState = {
  from: '',
  to: '',
  commission: ''
}
const AddUniversitySlabs = (props) => {
  let [state, setState] = useState(initState)
  let { visible, onSubmit, onClose, lastAmount } = props
  const events = {
    handleSubmit: (e) => {
      e.preventDefault()
      if (!state.from) {
        notification.warning({ message: 'Enter from commission.' })
        return
      }
      if (!state.to) {
        notification.warning({ message: 'Enter to commission.' })
        return
      }
      if (!state.commission) {
        notification.warning({ message: 'Enter commission.' })
        return
      }
      if (state.from <= lastAmount) {
        notification.warning({ message: 'From value cannot be less or equal to previous To value' })
        return
      }
      if (state.to <= state.from) {
        notification.warning({ message: 'To value cannot be less or equal to From value' })
        return
      }
      onSubmit(state)
      onClose()
      events.updateState(initState)
    },
    updateState: (data) => {
      setState((prevState) => {
        return {
          ...prevState,
          ...data
        }
      })
    }
  }

  useEffect(() => {
    if (lastAmount) {
      setState({
        ...state,
        from: Number(lastAmount) + 1
      })
    }
  }, [lastAmount])
  return (
    <Drawer
      title={'Add University Commission Slabs'}
      visible={visible}
      width={'25%'}
      onClose={onClose}>
      <Card bordered={false}>
        <div className='form-box mt-2'>
          <Form>
            <InputBox title={'From'}>
              <input type={'number'}
                     className={'form-control'}
                     placeholder={'From'}
                     value={state.from} onChange={({ target }) => {
                events.updateState({ from: target.value })
              }} />
            </InputBox>
            <InputBox title={'To'}>
              <input type={'number'}
                     className={'form-control'}
                     placeholder={'To'}
                     value={state.to} onChange={({ target }) => {
                events.updateState({ to: target.value })
              }} />
            </InputBox>
            <InputBox title={'Commission'}>
              <input type={'number'}
                     className={'form-control'}
                     placeholder={'Commission'}
                     value={state.commission} onChange={({ target }) => {
                events.updateState({ commission: target.value })
              }} />
            </InputBox>
            <Button onClick={events.handleSubmit} className='btn btn-success mt20'>
              SAVE
            </Button>
          </Form>
        </div>
      </Card>
    </Drawer>
  )
}
export default AddUniversitySlabs


//NewCommissionFlow